import { render, staticRenderFns } from "./heatmap-plot.vue?vue&type=template&id=036e91f0&scoped=true&"
import script from "./heatmap-plot.vue?vue&type=script&lang=js&"
export * from "./heatmap-plot.vue?vue&type=script&lang=js&"
import style0 from "./heatmap-plot.vue?vue&type=style&index=0&id=036e91f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e91f0",
  null
  
)

export default component.exports